import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
const testimonials = [{
  text: "Karen is absolutely amazing. I've been going to K'Bella for years and my skin has never looked better!",
  author: 'Sarah M.',
  rating: 5
}, {
  text: 'The best spa experience in Maricopa, hands down. She truly cares about her clients and takes the time to understand your needs.',
  author: 'Jessica T.',
  rating: 5
}, {
  text: "I got my lip blush done and it changed my whole look. So natural and beautiful! Highly recommend Karen's expertise.",
  author: 'Amanda L.',
  rating: 5
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      nextTestimonial();
    }, 6000);
    return () => clearInterval(timer);
  }, [currentIndex]);
  const nextTestimonial = () => {
    setDirection(1);
    setCurrentIndex(prevIndex => (prevIndex + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setDirection(-1);
    setCurrentIndex(prevIndex => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };
  const variants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 100 : -100,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      x: direction < 0 ? 100 : -100,
      opacity: 0
    })
  };
  // Swipe handling
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;
    if (isLeftSwipe) {
      nextTestimonial();
    }
    if (isRightSwipe) {
      prevTestimonial();
    }
    setTouchStart(0);
    setTouchEnd(0);
  };
  return <section className="py-20 md:py-32 bg-white overflow-hidden" data-id="element-161">
      <div className="container mx-auto px-4 md:px-6" data-id="element-162">
        <div className="text-center mb-16" data-id="element-163">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-brand-charcoal mb-4" data-id="element-164">
            What Our Clients Are Saying
          </h2>
          <div className="w-16 h-1 bg-brand-teal mx-auto mt-6" data-id="element-165"></div>
        </div>

        <div className="max-w-4xl mx-auto relative" data-id="element-166">
          <div className="relative h-[300px] md:h-[250px] flex items-center justify-center" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-167">
            <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-168">
              <motion.div key={currentIndex} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} className="absolute w-full px-8 md:px-16 text-center" data-id="element-169">
                <Quote className="w-12 h-12 text-brand-teal/20 mx-auto mb-6" data-id="element-170" />
                <div className="flex justify-center gap-1 mb-6 text-brand-teal" data-id="element-171">
                  {[...Array(testimonials[currentIndex].rating)].map((_, i) => <Star key={i} size={24} fill="currentColor" data-id="element-172" />)}
                </div>
                <p className="text-xl md:text-2xl font-heading text-brand-charcoal italic mb-8 leading-relaxed" data-id="element-173">
                  "{testimonials[currentIndex].text}"
                </p>
                <p className="font-semibold text-brand-charcoal uppercase tracking-wider text-sm" data-id="element-174">
                  — {testimonials[currentIndex].author}
                </p>
              </motion.div>
            </AnimatePresence>
          </div>

          <button onClick={prevTestimonial} className="absolute left-0 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-brand-gray flex items-center justify-center text-brand-charcoal hover:bg-brand-teal hover:text-white transition-colors hidden md:flex" aria-label="Previous testimonial" data-id="element-175">
            <ChevronLeft size={24} data-id="element-176" />
          </button>

          <button onClick={nextTestimonial} className="absolute right-0 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-brand-gray flex items-center justify-center text-brand-charcoal hover:bg-brand-teal hover:text-white transition-colors hidden md:flex" aria-label="Next testimonial" data-id="element-177">
            <ChevronRight size={24} data-id="element-178" />
          </button>

          <div className="flex justify-center gap-3 mt-8" data-id="element-179">
            {testimonials.map((_, index) => <button key={index} onClick={() => {
            setDirection(index > currentIndex ? 1 : -1);
            setCurrentIndex(index);
          }} className={`w-2.5 h-2.5 rounded-full transition-colors ${index === currentIndex ? 'bg-brand-teal' : 'bg-brand-gray hover:bg-brand-teal/50'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-180" />)}
          </div>
        </div>
      </div>
    </section>;
}